import React from "react";


export default function RenderIfElse(props) {
    return props.condition ? props.children[0] : props.children[1];
}